import Text from 'components/base/Text';
import { StyledNoDataInfoBox } from './NoDataInfoBox.style';

const NoDataInfoBox = ({ showNoDataInfoBox, infoBoxTextEllipsisAfter }) => {
  if (!showNoDataInfoBox) {
    return null;
  }

  return (
    <StyledNoDataInfoBox>
      <Text
        size='small'
        align='center'
        ellipsisAfter={infoBoxTextEllipsisAfter}
      >
        No matching results, adjust filters as needed
      </Text>
    </StyledNoDataInfoBox>
  );
};

export default NoDataInfoBox;
